import { type ISeriesAssociation } from '@/types/series.types';
import { PostJson as Post } from '../helpers';
import { SeriesPath } from './path';

export default function SetSeriesEvents({
	channel,
	seriesUuid,
	eventUuids,
}: {
	channel: number;
	seriesUuid: string;
	eventUuids: string[];
}) {
	return Post<{ eventUuids: string[] }, ISeriesAssociation>({
		path: SeriesPath(channel, `/${seriesUuid}/events`),
		data: { eventUuids },
	});
}
